<template>
    <div id="vipConfirm" class="cover">
        <div class="vippopup-con cover_center_panel">
            <img class="popup-bj" src="./img/vip-bar-img.png" />
            <div class="panel_tips">
                <span class="color_text">很抱歉，此功能成本过高，仅限付费用户使用，请谅解</span>
                <img class="finger_down" src="./img/finger_down.png" alt="">
                <div class="tips_text">长久的发展，一定是双向奔赴<br/>请</div>
                <button @click="openVip" class="update_btn">升级权限</button>
                <!-- <div><span class="buy_words" @click="closeCover('buy_words')">购买字数包</span></div> -->
                <div class="bottom_text">已经有<span>253421</span>位朋友为懒人办公的发展，做过杰出贡献</div>
            </div>
            <div class="close_btn" @click="closeCover('')"></div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        props: [],
        data() {
            return {
                
            }
        },
        created() {
        
        },
        methods: {
            closeCover(action){
                this.$emit('confirm',{flag:false,action:action})
            },
			openVip(){
				this.$emit("confirm",{flag:true,action:""})
                this.$router.push("/membership")
			}
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .vippopup-con{
		width: 480px;
        height: 520px;
		position: relative;
        background-color: transparent;
        background-color: #fff;
        border-radius: 4px;
        padding-top: 45px;
		.popup-bj{
			width: 157px;
            display: block;
            margin: 0 auto 26px;
		}
		.panel_tips{
            text-align: center;
            line-height: 48px;
			.color_text{
                background-image: linear-gradient(to right, #209df2, #ef5a4f);
                background-clip: text;
                color: transparent;
                -webkit-text-fill-color: transparent;
			}
			.finger_down{
				display: block;
                margin: 15px auto;
                width: 24px;
			}
			.update_btn{
                display: block;
                margin: 17px auto;
                height: 48px;
                width: 240px;
                border: none;
                background-color: #424242;
                border-radius: 5px;
                color: #fff;
                font-size: 14px;
                user-select: none;
			}
            .bottom_text{
                color: #999;
                span{
                    padding: 0 8px;
                    color: #ff5543;
                    font-size: 20px;
                }
            }
            .buy_words{cursor: pointer;
                color: #ccc;
                text-decoration:underline;
            }
		}
        .close_btn{
            position: absolute;
            bottom: -80px;
            left: 50%;
            margin-left: -15px;
            width: 30px;
            height: 30px;
            background-image: url("./img/update_close.png");
            background-size: 100% 100%;
            cursor: pointer;
        }
	}
</style>